
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.645","height":"17.277"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.693 .5)","fill":"none","stroke":"#1472e6"}},[_c('path',{attrs:{"d":"M19.323 3.856a1.649 1.649 0 11-1.649-1.649 1.649 1.649 0 011.649 1.649z"}}),_c('rect',{attrs:{"width":"22.421","height":"16.277","rx":"1.666","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M0 15.839l6.613-9.936 5.476 6.7 3.551-3.79 6.606 7.022","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    